const guardSvgElementDimension = (size: number): number => {
	return Math.max(0, Number.isFinite(size) ? size : 0);
};

export { guardSvgElementDimension };
